module.exports = __webpack_public_path__ + "c97ef698a2e9a81446133a64fa159d30.png";